import React, { Component, PureComponent } from 'react'
import styles from './style.scss'
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
// import { Link } from 'react-router-dom'
import moment from 'moment'
import classnames from 'classnames'

import Dropdown from '../../../components/Dropdown'
import Modal from '../../../components/Modal'
import { channelLogo } from '../../../utils/convo'
import { Button } from 'sofia-ui'
import { Link } from 'react-router-dom'
import axios from '../../../store/http/axios'
import { isEqual } from 'lodash'

const QUERY = gql`
query($uuid: String) {
  admins {
    id
    _id
    first_name
    last_name
    email
  }
  conversation(_id:$uuid) {
    id
    _id
    tags
    assignedTo
    last_message
    user_conversations {
      id
      user {
        id
        _id
        first_name
        last_name
        phone_number
        email
        messenger_id
        clients {
          id
          _id
          state
          requests {
            id
            _id
            state
          }
        }
        tutors {
          id
          _id
          photo
          state
          requests {
            id
            _id
            state
          }
        }
      }
    }
    messages(orderBy: "created_at", order: ASC) {
      id
      _id
      user_uuid
      user {
        id
        _id
        first_name
        last_name
        phone_number
        email
      }
      content
      body
      detailed_body
      type
    	details
      raw_input
      provider
      created_at
    }
  }
}
`

const UPDATE_CONVERSATION = gql`
mutation updateConversation($input: conversationMutation) {
  updateConversation(input: $input) {
    id
    _id
    tags
  }
}
`

const Tag = ({ name, tags, uuid }) => (
  <Mutation mutation={UPDATE_CONVERSATION}>
    {(update, { data }) => (
      <div className={classnames(styles.tag, tags.includes(name) && styles.active)} onClick={e => {
        let newTags = [...tags];
        tags.includes(name) ? newTags.splice(tags.indexOf(name), 1) : newTags.push(name);
        update({ variables: { input: { 
          _id: uuid, 
          tags: newTags
        }}})
      }}>
        {name}
      </div>
    )}
  </Mutation> 
)

const Wrapper = ({...props, uuid}) => {
  if (!uuid) return null
  return <Query
    query={QUERY}
    variables={{
      uuid: uuid
    }}
    pollInterval={5000}
    >
    {({ loading, error, data, refetch }) => {
      if (loading) return <p>Loading...</p>;
      if (error) {
        console.error(error)
        return <p>Error :(</p>
      };
      console.log('DATA', data)
      return <MessageDetails {...props} {...data} refetch={() => refetch()} />
    }}
  </Query>
}


class MessageDetails extends Component {

  constructor(props) {
    super(props)
    this.state = {
      channel: 'EMAIL',
      body: '',
      subject: '',
      detailsModal: true,
      detailed_body: '',
      attachments: []
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state)
  }

  newMessage = async (admin, user) => {
    await axios.post('messaging', {
      body: this.state.body,
      channel: this.state.channel,
      admin_id: admin.id,
      user: user
    })
    this.setState({ body: '' })
  }

  render() {

    const { channel, subject, detailsModal, detailed_body, attachments } = this.state
    const { conversation: { messages, tags, user_conversations }, admins, refetch } = this.props

      console.log("ATTATCH", attachments)

      const user = user_conversations[0].user

      let channels = []

      if (user.email)
        channels.push({
          label: <div>{channelLogo("EMAIL")} Email</div>,
          value: "EMAIL"
        })
      if (user.phone_number)
        channels.push({
          label: <div>{channelLogo("SMS")} SMS</div>,
          value: "SMS"
        })
      if (user.messenger_id)
        channels.push({
          label: <div>{channelLogo("MESSENGER")} Messenger</div>,
          value: "MESSENGER"
        })
   
      return <React.Fragment>

        <Modal
          title={subject}
          close={() => this.setState({ detailsModal: true })}
          hide={detailsModal}
        >
          {!!attachments && !!attachments.length && <div className={styles.attachments}>
            <h5>Pièces jointes</h5>
            {attachments.map(({ url, name }, key) => <a key={key} href={url} target="_blank"><span>{name}</span></a>)}
          
          </div>}
          <div className={styles['danger-zone']} dangerouslySetInnerHTML={{ __html: detailed_body }}></div>
        </Modal>

        <div className={styles.split}>
          <div className={styles.messages}>
            <div className={styles.scroll}>
              {messages.map(({ body, user, created_at, provider, detailed_body, details, raw_input }) => <div className={styles.message}>
                <div className={styles.title}>
                  <b>{provider !== "ADMIN" ? user.first_name || user.email : "Sofia - Admin"}</b> • <small>{moment(created_at).format("YY-MM-DD hh:mm")}  {channelLogo(provider)}</small>
                </div>
                <div dangerouslySetInnerHTML={{ __html: body.replace(/(?:\r\n|\r|\n)/g, '<br />') }} />
                {provider === "EMAIL" && <div className={styles.view}>
                  <Button color='blue' small onClick={() => {
                    console.log('DETAILS', details)
                    this.setState({ 
                      subject: details ? details.subject : raw_input.subject,
                      detailsModal: false,
                      detailed_body,
                      attachments: details.attachments
                    })
                  }}>Voir le message original</Button>
                </div>}
              </div>)}
            </div>

            <div className={styles.new}>
              <textarea rows="4" value={this.state.body} onChange={e => this.setState({ body: e.target.value })}/>

              <div className={styles.channel}>
                <Dropdown
                  top
                  label={<div>{channelLogo(channel)}</div>} 
                  options={channels}
                  onSelect={channel => this.setState({ channel })}
                />
              </div>
              <div className={styles.send} onClick={() => {
                this.newMessage(admins[0], user)
                setTimeout(() => {
                  console.log('REFETCH')
                  refetch()
                }, 500)
              }}>
                <i className="far fa-paper-plane"></i>
              </div>
            </div>
          </div>

          <div className={styles.details}>
            <h3>Détails</h3>

            <div className={styles.tags}>
              <Tag name="New" tags={tags} uuid={this.props.uuid} />
              <Tag name="Awaiting Data" tags={tags} uuid={this.props.uuid} />
              <Tag name="Need followup" tags={tags} uuid={this.props.uuid} />
              <Tag name="Urgent" tags={tags} uuid={this.props.uuid} />
              <Tag name="Closed" tags={tags} uuid={this.props.uuid} />
              <Tag name="Spam" tags={tags} uuid={this.props.uuid} />
              <Tag name="old" tags={tags} uuid={this.props.uuid} />
              <Tag name="Development" tags={tags} uuid={this.props.uuid} />
            </div>

            {user && <div className={styles.dbox}>
              {user.first_name && <div><b>{user.first_name} {user.last_name}</b></div>}
              {user.email && <span>{user.email} <br/></span>}
              {user.phone_number && <span>{user.phone_number} <br/></span>}
              {user.messenger_id && <span>{user.messenger_id} <br/></span>}
              <Link to={`/users/${user.tutors.length ? 'tutor' : 'client'}/${user._id}`}>
                <Button className={styles.button} color='dark' small>Voir le profil</Button>
              </Link>
            </div>}
            

          </div>
        </div>
      </React.Fragment>
  }
}

export default Wrapper



// WEBPACK FOOTER //
// ./src/containers/messages/Details/index.js